import { ComboboxGroupItem } from '@node-space/ui-components'
import { useIndustriesQuery } from './useIndustriesQuery'

export const useIndustryOptions = () => {
  const { data: industries, isPending, isError } = useIndustriesQuery()
  const industryOptions: ComboboxGroupItem[] = industries?.map(industry => ({
    groupLabelHeader: industry?.name,
    items: industry?.children?.map(child => ({
      value: child?.reference,
      label: child?.name,
    })),
  }))

  return { industryOptions: industryOptions ?? [], isPending, error: isError }
}
